var map = {
	"./dune.jpg": 895,
	"./everything.jpg": 569,
	"./infinite.jpg": 297,
	"./joker.jpg": 64,
	"./lightyear.jpg": 806,
	"./morbius.jpg": 552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 590;